// extracted by mini-css-extract-plugin
module.exports = {"field":"TextFileAddModal_field__1wL2k"};